import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { countdownParts } from '../../utils/countdownParts';

/* DD · HH · MM · SS to the auction's end, re-read from the wall clock every second
 * (a bid can extend the end under it, so the deadline is a prop, never captured).
 * `tone` picks the ink: the homepage is dark-on-dark like the rest of the landing,
 * the portal panel wants its gold. */
export const AuctionCountdown: React.FC<{
  endsAt: string | Date;
  tone?: { ink: string; label: string; box: string; border: string };
  compact?: boolean;
}> = ({ endsAt, tone, compact }) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(t);
  }, []);
  const left = Math.max(
    0,
    Math.floor((new Date(endsAt).getTime() - now) / 1000)
  );
  const p = countdownParts(left);
  const ink = tone?.ink || '#eef6fb';
  const label = tone?.label || '#8ea3b3';
  const box = tone?.box || 'rgba(255,255,255,0.06)';
  const border = tone?.border || 'rgba(140,170,190,0.18)';
  const cells: Array<[string, number]> = [
    ['Days', p.days],
    ['Hours', p.hours],
    ['Mins', p.minutes],
    ['Secs', p.seconds]
  ];
  return (
    <Box
      sx={{
        display: 'flex',
        gap: compact ? 0.75 : 1.25,
        alignItems: 'stretch'
      }}
    >
      {cells.map(([name, value]) => (
        <Box
          key={name}
          sx={{
            flex: '1 1 0',
            minWidth: 0,
            textAlign: 'center',
            px: compact ? 0.5 : 1,
            py: compact ? 0.75 : 1.25,
            borderRadius: '10px',
            background: box,
            border: `1px solid ${border}`
          }}
        >
          <Typography
            sx={{
              font: `800 ${compact ? 20 : 28}px/1 ui-monospace, Menlo, Consolas, monospace`,
              fontVariantNumeric: 'tabular-nums',
              color: ink
            }}
          >
            {String(value).padStart(2, '0')}
          </Typography>
          <Typography
            sx={{
              mt: 0.5,
              font: `700 ${compact ? 9 : 10}px/1 ui-monospace, Menlo, Consolas, monospace`,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: label
            }}
          >
            {name}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default AuctionCountdown;
